import { makeGraphqlRequestCloud } from 'api/graphql/graphQLClient';
import { Compounds } from '@/graphql/cloud/compounds/Compounds.graphql';
import { CreateCompound } from '@/graphql/cloud/compounds/mutations/CreateCompound.graphql';

export const apiCompounds = {
  async getCompounds(search = '', sequenceId) {
    const searchPattern = `%${search ?? ''}%`;
    const { sequence_calibration: sequenceCalibrations = [] } = await makeGraphqlRequestCloud(
      Compounds,
      {
        search: searchPattern,
        sequenceId,
      },
    );

    const compoundsMap = new Map();

    sequenceCalibrations
      .filter(({ calibration }) => {
        const attachedSequences = calibration?.sequence_calibrations ?? [];

        return attachedSequences.every(
          (seqCalibration) => seqCalibration.sequence_id === sequenceId,
        );
      })
      .forEach(({ calibration }) => {
        if (!calibration?.compound) return;

        const { compound } = calibration;

        let normalized = compoundsMap.get(compound.id);
        if (!normalized) {
          normalized = {
            id: compound.id,
            name: compound.name,
            unit: null,
            sequence_compounds: (compound.sequence_compounds ?? []).map((sequenceCompound) => ({
              ...sequenceCompound,
              sample_sequence_compounds: (sequenceCompound.sample_sequence_compounds ?? []).map(
                (sampleSequenceCompound) => ({
                  ...sampleSequenceCompound,
                }),
              ),
            })),
            calibrations: [],
          };

          compoundsMap.set(compound.id, normalized);
        }

        const calibrationUnit = calibration?.calibration_levels?.[0]?.unit ?? null;

        normalized.calibrations.push({
          id: calibration.id,
          calibration_compound: calibration.calibration_compound,
          sequence_calibrations: calibration.sequence_calibrations ?? [],
          unit: calibrationUnit,
        });

        if (!normalized.unit && calibrationUnit) {
          normalized.unit = calibrationUnit;
        }
      });

    return Array.from(compoundsMap.values()).sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
    );
  },
  async createCompound(compoundName) {
    const { compound } = await makeGraphqlRequestCloud(CreateCompound, {
      name: compoundName,
    });

    return {
      ...compound,
      unit: null,
      sequence_compounds: [],
      calibrations: [],
    };
  },
};
